import {NavigationComponent} from "../components/public/navigation.component";
import {useEffect} from "react";
import axios from "axios";

export const IndexPage = () => {

    /*useEffect(() => {
        const fetchStats = async () => {
            try {
                const customerId = "7FUS4BCT8TV5YQX2";
                const statsRequest = await axios.post(
                    "http://localhost:3001/stats/7FUS4BCT8TV5YQX2",
                    { customerId }
                );

                if (statsRequest.status === 200) {
                    console.log("OK");
                } else {
                    console.log("(1) NO OK.");
                }
            } catch (e) {
                console.log("(2) NO OK.", e);
            }
        };

        fetchStats();
    }, []);*/

  return (
      <>
        <div className={"tesapp-tesapp"}>
            <div className={"tesapp-component"}>
                <NavigationComponent/>
                <div className={"tesapp-banner"}>
                    <div className={"tesapp-line-space"}/>
                    <div className={"tesapp-banner-box"}>
                        <div className={"tesapp-box-header"}/>
                        <div className={"tesapp-box-content"}>
                            <h1 className={"tesapp-title"}>TEMNOGRAPHY<span className={"tesapp-trademark"}>®</span></h1>
                            <p className={"tesapp-text-super-upper"}>Pomaga lekarzom w klinikach uratować więcej istnień
                                ludzkich i zmniejszyć
                                niepełnosprawność.</p>
                        </div>
                        <div className="tesapp-box-footer custom-shape-divider-top-1726681364">
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                                 preserveAspectRatio="none">
                                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-container"}
                     style={{marginTop: "-50px", display: "block", paddingTop: 0}}>
                    <div className={"tesapp-container-content"} id={"jak-to-dziala"}>
                        <h1>Jak to działa?</h1>
                        <br/>
                        <div className={"tesapp-c-component"}>
                            <h3 className={"tesapp-title-black"}>Tkanka i detekcja:</h3>
                            <p className={"tesapp-text-upper"}>
                                Pola elektromagnetyczne, generowane przez mikrofale,
                                rozprzestrzeniają się w tkankach poddawanych złożonym zmianom generowanym przez odbicia,
                                załamania i zmiany kąta fazowego, rozważane zarówno w domenach czasu, jak i
                                przestrzeni.<br/><br/>
                                Zakłócenia te zmieniają charakterystyczny odcisk zdrowego mózgu i są wychwytywane przez
                                Temnograph, który używa ich jako radaru do określania obecności lub braku poszukiwanych
                                zmian.
                            </p>
                        </div>
                        <br/>
                        <div className={"tesapp-c-component"}>
                            <h3 className={"tesapp-title-black"}>Bezpieczeńswo:</h3>
                            <p className={"tesapp-text-upper"}>
                                TES jest nieinwazyjny, nie wykorzystuje promieniowania jonizującego i
                                badanie
                                można powtarzać bez ograniczeń. TES wykorzystuje bardzo małą moc, intensywność i czas
                                ekspozycji
                                są utrzymywane na minimalnym poziomie, aby zapewnić bezpieczeństwo zarówno pacjentom,
                                jak i
                                operatorom.
                            </p>
                        </div>
                        <br/>
                        <div className={"tesapp-c-component"}>
                            <h3 className={"tesapp-title-black"}>Szybko i łatwo:</h3>
                            <p className={"tesapp-text-upper"}><b>Technologia TES</b>, poprzez proces wykrywania,
                                bezpośrednio zwraca wynik badania
                                jako proste "TAK", jeśli docelowe uszkodzenie mózgu jest obecne lub "NIE", jeśli jest
                                nieobecne. Nie
                                wymaga interpretacji przez eksperta. Wynik pokazuje lokalizację wykrytej zmiany.
                            </p>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-banner"} style={{margin: "50px 0"}} id={"zalety"}>
                    <div className={"tesapp-line-space tesapp-container"}>
                        <div className={"tesapp-space-header"}>
                            <h1 className={"tesapp-title"}>Zalety korzystania<br/> z TEMNOGRAPHY<span
                                className={"tesapp-trademark"}>®</span></h1>
                            <div className={"tesapp-space-flex"}>
                                <div className={"tesapp-space-box"}>
                                    <div className={"tesapp-box-icon"}>
                                        <span className="material-symbols-outlined">speed</span>
                                    </div>
                                    <div className={"tesapp-box-container"}>
                                        <h3>Szybki</h3>
                                        <p>Wystarczy 5 minut na badanie</p>
                                    </div>
                                </div>
                                <div className={"tesapp-space-box"}>
                                    <div className={"tesapp-box-icon"}>
                                        <span className="material-symbols-outlined">accessibility</span>
                                    </div>
                                    <div className={"tesapp-box-container"}>
                                        <h3>Przenośny</h3>
                                        <p>Niewielki rozmiar, lekko, nadający się do transportu</p>
                                    </div>
                                </div>
                                <div className={"tesapp-space-box"}>
                                    <div className={"tesapp-box-icon"}>
                                        <span className="material-symbols-outlined">verified_user</span>
                                    </div>
                                    <div className={"tesapp-box-container"}>
                                        <h3>Bezpieczny</h3>
                                        <p>niska moc/natężenie promieniowania niejonizującego</p>
                                    </div>
                                </div>
                                <div className={"tesapp-space-box"}>
                                    <div className={"tesapp-box-icon"}>
                                        <span className="material-symbols-outlined">star_rate</span>
                                    </div>
                                    <div className={"tesapp-box-container"}>
                                        <h3>Niezawodny</h3>
                                        <p>Bardzo wysoka swoistość i czułość</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-container"}
                     style={{marginTop: "-70px", display: "block", paddingTop: 0}}>
                    <div className={"tesapp-container-content"} id={"wersje-produktu"}>
                        <h1>Serie produktu</h1><br/>
                        <div className={"tesapp-products-container"}>
                            <div className={"tesapp-product-once"}>
                                <div className={"tesapp-product-image"}>
                                    <img src={"./tes-ht100-new2.png"}
                                         width={300}/>
                                </div>
                                <div className={"tesapp-product-header"}>
                                    <h1>TES HT 100</h1>
                                    <a href={"https://www.temnography.com/products/"} target={"_blank"}
                                       className={"tesapp-btn btn-desktop"}>Zobacz specyfikacje</a>
                                </div>
                                <div className={"tesapp-product-description tesapp-text-upper"}><br/>
                                    Zapewnia szybszą identyfikacje krwotoku mózgowego trwającego w udarze i innych
                                    przypadkach
                                    możliwego ryzyka wystąpienia krwawienia mózgowego z wynikiem TAK/NIE. <b>TES HT 100</b> może być
                                    stosowany tam, gdzie przebywają pacjenci.
                                </div>
                                <a href={"https://www.temnography.com/products/"} target={"_blank"}
                                   className={"tesapp-btn btn-mobile"}>Zobacz specyfikacje</a>
                            </div>
                            <div className={"tesapp-product-once"}>
                                <div className={"tesapp-product-image"}>
                                    <img src={"./TES-HT-1.png"}
                                         width={300}/>
                                </div>
                                <div className={"tesapp-product-header"}>
                                    <h1>TES HT</h1>
                                    <a href={"https://www.temnography.com/en/products/"} target={"_blank"}
                                       className={"tesapp-btn btn-desktop"}>Zobacz specyfikacje</a>
                                </div>
                                <div className={"tesapp-product-description tesapp-text-upper"}><br/>
                                    Zapewnia szybkie wykrywanie uszkodzeń mózgu w przypadku możliwych uszkodzeń mózgu,
                                    zapewniając wynik TAK/NIE. <b>TES
                                        HT</b> może być
                                    stosowany tam, gdzie przebywają pacjenci.
                                </div>

                                <a href={"https://www.temnography.com/en/products/"} target={"_blank"}
                                   className={"tesapp-btn btn-mobile"}>Zobacz specyfikacje</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-footer-2 tesapp-c-component"} id="dystrybutor">
                    <h1 className={"tesapp-title-black"}>Dystrybutor</h1>
                    <div className={"tesapp-footer-body"}>
                        <div className={"tesapp-distributor-container"}>
                            <img src={"logo.png"} className={"tesapp-cmp-icon"} width={160} height={50}/>
                            <div className={"tesapp-cmp-present"}>
                                <div className={"tesapp-distributor-info"}>
                                    <div><b>Medical Service Sp. z o. o.</b></div>
                                    <div>ul. Jordana 25</div>
                                    <div>40-952 Katowice</div>
                                </div>
                            </div>
                            <div className={"tesapp-cmp-more-info"}>
                                <div>NIP: 9542468164</div>
                                <div>Tel./Fax 257 84 40 | <b>+48 605405477</b></div>
                                <div>Mail: ms@medical-service.pl</div>
                            </div>
                        </div>
                        <div className={"footer-body-action"}>
                            <a href={"http://medical-service.pl"} target={"_blank"} className={"tesapp-btn"}>Otwórz stronę internetową</a>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-footer"}>
                    <div className={"tesapp-footer-col-left"}>
                        <div className={"tesapp-distributor"}>
                            <div className={"tesapp-text-upper-white-mdk384"}>&copy; 2024 Wszelkie prawa zastrzeżone
                            </div>
                        </div>
                    </div>
                    <div className={"tesapp-footer-col-right"}>
                        Stworzono przez <b><a href={"//proevent-solutions.pl/"} style={{color: "white", textDecoration: "none"}}
                                              target={"_blank"}>PROEVENT SOLUTIONS Sp. z o. o.</a></b>
                    </div>
                </div>
            </div>

        </div>
      </>
  )
}